import type { FC, ReactNode } from 'react';
import { useState } from 'react';
import { useDrag } from 'react-dnd';
import ExpandLessRounded from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import { Box, ListItem, Stack } from '@mui/material';

import { styles } from './index.styles';

export interface WorkspaceVariableListItemProps {
  shapings: any;
  shapingSet: any;
  shapingId: number;
  variableId: number;
  variableName: string;
  variableShortName: string;
  children?: ReactNode;
  clickHandler?: (id: number | string) => any;
  collapsible?: boolean;
  dragSourceType?: any;
  id: string | number;
  title: string;
}

const WorkspaceVariableListItem: FC<WorkspaceVariableListItemProps> = ({
  shapings,
  shapingSet,
  shapingId,
  variableId,
  variableName,
  variableShortName,
  children,
  clickHandler,
  collapsible,
  dragSourceType,
  id,
  title,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [, drag] = useDrag({
    type: dragSourceType,
    item: {
      shapings,
      shapingSet,
      shapingId,
      variableId,
      variableName,
      variableShortName,
      clickHandler,
      collapsible,
      dragSourceType,
      id,
      title,
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const handleClick = () => {
    if (collapsible) setIsActive((prev) => !prev);
    clickHandler && clickHandler(id);
  };

  return (
    <ListItem ref={drag} dense disableGutters sx={styles.listItem}>
      <Stack direction="column" sx={styles.contentWrapper}>
        <Stack direction="row" sx={styles.headline} onClick={handleClick}>
          <Box>{title}</Box>
          {collapsible && (
            <Box>
              {isActive ? (
                <ExpandLessRounded color="primary" />
              ) : (
                <ExpandMoreRounded color="primary" />
              )}
            </Box>
          )}
        </Stack>
        {isActive && <Box sx={styles.nestedContent}>{children}</Box>}
      </Stack>
    </ListItem>
  );
};

export default WorkspaceVariableListItem;
